
import { Tabs } from "antd";

import { useLocation } from "react-router-dom";
import { accessChecker } from "../../lib/functions";

import QuotationEntry from "../Quotation/QuotationEntry";
import QuotationRecord from "../QuotationRecord";

const QuotationTabs = ({ authInfo }) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const activeTab = params.get("tab") || "entry";

  const menuData = [
    {
      label: "Quotation Entry",
      key: "entry",
      value: "quotation_entry",
      children: (
        <>
          <QuotationEntry authInfo={authInfo} />
        </>
      ),
    },
    {
      label: "Quotation Record",
      key: "record",
      value: "quotation_record",
      children: (
        <>
          <QuotationRecord />
        </>
      ),
    },
  ];

  const filteredMenuData = menuData.filter((menuItem) =>
    accessChecker(menuItem.value)
  );
  return (
    <Tabs
      defaultActiveKey={activeTab}
      type="card"
      size="medium"
      style={{ marginBottom: 32 }}
      items={filteredMenuData}
    />
  );
};

export default QuotationTabs;
